<template>
	<div id="cc_center2">
		<div class="cc-header">今日课程安排</div>
		<dv-scroll-board :config="config" class="today_class" />
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgCode = storage.getItem("orgCode");
	export default {
		data() {
			return {
				config: {}
			};
		},
		mounted() {
			this.initData();
			let _this = this;
			// 定时器刷新，30分钟
			this.interval = setInterval(() => {
				_this.initData();
			}, 1000 * 60 * 30);
		},
		methods: {
			initData() {
				let _this = this;
				this.$http.get("/dataView/clubClass/edu/getOrgCourseInfoByToday?orgCode=" + orgCode).then(res => {
					var resultList = [];
					if (res.data.code === 200) {
						for (var i = 0; i < res.data.result.length; i++) {
							var result = [];
							var obj = res.data.result[i];
							result.push(obj.orgName);
							result.push(obj.courseName);
							result.push(obj.startTime);
							resultList.push(result);
						}
						if (res.data.result.length > 0) {
							_this.config = {
								header: ['学校名称', '课程名称', '上课时间'],
								data: resultList,
								headerBGC: '',
								oddRowBGC: 'rgba(96, 144, 255, 0.1)',
								evenRowBGC: 'rgba(0, 170, 255, 0.01)',
								waitTime: 1500,
								headerHeight: 30,
								rowNum: 5, //表格行数
								align: ['center', 'center', 'center']
							}
						} else {
							_this.config = {
								data: [['<div class="noneData">暂无课程</div>']],
								evenRowBGC: 'none',
								rowNum: 1,
								align: ['center']
							};
						}
					}
				})
			}
		},
	beforeDestroy() {
		clearInterval(this.interval);
	}
	};
</script>

<style lang="scss">
	#cc_center2 {
		height: 100%;
		padding: 0 0.3rem;

		.cc-header {
			width: 100%;
			text-align: center;
			background: url("../../assets/img/ac_titbg.png") center no-repeat;
			background-size: 100%;
			color: #34deff;
			font-size: 0.22rem;
			font-weight: bold;
			height: 15%;
		}


		.today_class {
			height: 76%;
		}

		.today_class .header {
			background: none;
			border-bottom: 1px solid #029aff;
			color: #029aff;
			font-size: 0.2rem;
			font-weight: bold;
		}

		.today_class .row-item {
			color: #4ea4ff ;
			font-size: 0.2rem;
		}
	}
</style>